import './index.scss'
import '../../assets/scripts/jQuery.positionSticky.min.js'
import '../../assets/scripts/swiper-bundle.min.js'
import Swiper from 'swiper/js/swiper.min'
import 'swiper/css/swiper.min.css'
import '@fancyapps/fancybox/dist/jquery.fancybox.min'
import '../../assets/scripts/hScroll.js'
$(document).ready(function () {
  navSec()
  });
var swiperNum = 0
function navSec(){
  let $headitab = $('.comp-header-nav .nav-item .itul')
    $headitab.addClass('active')
    let head = $('.comp-header').height()
    console.log('头部高度',head);
    // $('.section1').css({'margin-top':head+'px'})

    // 定位效果
    //初始化
		new hScroll({
			nav1: '.tab>.tab_i', //导航对应的元素
			nav2: '.tabitem', //监听的元素
			checkClass: 'active' //选中的样式
		});
}

  var swiper2 = new Swiper(".section5 .table-swiper .mySwiper", {
    effect : 'fade',
    fadeEffect: {
      crossFade: true,
    },
    allowTouchMove: false,
    autoHeight: true,
    watchOverflow: true,
    on:{
      init: function(swiper){
        swiperNum = this.realIndex
        $('.section5 .table-tab div').eq(this.realIndex).addClass('active')
      },
      slideChangeTransitionStart: function(){
        swiperNum = this.realIndex
        $('.section5 .table-tab div').eq(this.realIndex).addClass('active').siblings().removeClass('active')
      },
    }
  })
  $('.section5 .table-tab div').on('click',function(){
    $('.table-swiper .swiper-slide').find('table').removeClass('after').removeClass('before')
    let index = $(this).index()
    swiper2.slideTo(index)
    swiperNum = index
    updateTbodyScroll(index);
  })
  let headgd = $('.comp-header').height();
  $('.section2').positionSticky({offsetTop: headgd});  
  $(window).on('resize', function() {
    location.reload(); 
    navSec()
  });

  // 表格滑动
  function updateTbodyScroll(index) {  
    // 获取对应索引的tbody  
    var $tbody = $('.table-swiper .swiper-slide').eq(index).find('tbody');  

    // 解除之前的滚动事件处理程序（防止绑定多次）  
    $tbody.off('scroll');  

    // 绑定新的滚动事件处理程序  
    $tbody.on('scroll', function() {  
      var currentScrollTop = $(this).scrollTop();  
      var maxScrollTop = $(this)[0].scrollHeight - $(this).outerHeight();  

      if (currentScrollTop > 0) {  
        $(this).closest('table').addClass('before');  
      }  

      if (currentScrollTop < maxScrollTop) {  
        $(this).closest('table').addClass('after');  
      }  

      if (currentScrollTop <= 0) {  
        $(this).closest('table').removeClass('before');  
      }  

      if (currentScrollTop >= maxScrollTop) {  
        $(this).closest('table').removeClass('after');  
      }  
    });  

    // 初始化滚动状态，确保在点击时立即更新状态  
    $tbody.scroll(); // 手动触发滚动检查  
  }  
  updateTbodyScroll(swiperNum); 